import * as React from 'react';
import { FC, useCallback, useEffect, useState } from 'react';
import {
    useListContext,
} from 'react-admin';
import { Typography, Card, Grid, CardContent, Chip, Divider, CardActions, Button, Box } from '@mui/material';
import jwt_decode from "jwt-decode";

// import components
import InfoDialog from './dialogs/InfoDialog';
import ActivateSubscription from './dialogs/ActivateSubscription';
import { BASE_ASSETS_URL } from '../../config';

const LoadedGridList = () => {

    const { data } = useListContext();
    if (!data) return null;

    return (
        <Box sx={{ pl: 5, pr: 4, pt: 3, m: 0 }}>
            <Grid container spacing={3}>
                {data?.map((record: any) => (
                    <Grid item xs={11} md={3}>
                        <Card sx={{ borderRadius: 10 }}>
                            <CardContent>
                                <Box sx={{ marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img height="60" src={`${BASE_ASSETS_URL}${record.icon_path}`} />
                                </Box>
                                <Typography sx={{ marginTop: 2, fontSize: 20, fontWeight: "bold", textAlign: "center" }} color="textSecondary" gutterBottom>
                                    {record.package_name}
                                </Typography>
                                <Typography sx={{ marginTop: 0, fontSize: 15, textAlign: "center" }} color="textSecondary" gutterBottom>
                                    {record.description ? record.description.substring(0, 90) + ' ...' : " "}
                                </Typography>
                                <Typography sx={{ fontSize: 15, textAlign: "center", height: 35 }} color="textSecondary" gutterBottom>
                                    <Chip label={`${record.package_duration} ${record.unit}`} sx={{ marginRight: 2 }} />
                                    <Chip label={`${record.price} €`} />
                                </Typography>
                            </CardContent>
                            <Box style={{ padding: 9 }}>
                                <Divider />
                            </Box>
                            <CardActions sx={{ alignItems: "center", pt: 0, justifyContent: "center" }}>
                                <InfoDialog record={record} />
                                {/* <ActivateSubscription record={record} packagesList={record} /> */}
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

const GridList = () => {
    return <LoadedGridList />
};

export default (GridList);